import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { message } from 'antd';
import { clearSession } from '../utils/api';

export const IDLE_MINUTES = 60;
const KEY = 'lastActive';
const EVENTS = ['mousedown', 'keydown', 'wheel', 'touchstart'];

/** Signs the user out after IDLE_MINUTES without mouse or keyboard use; activity in any open tab counts. */
export default function IdleLogout() {
  const navigate = useNavigate();
  useEffect(() => {
    let last = 0;
    const touch = () => {
      const now = Date.now();
      if (now - last > 30000) {
        last = now;
        localStorage.setItem(KEY, String(now));
      }
    };
    touch();
    EVENTS.forEach((e) => window.addEventListener(e, touch, { passive: true }));
    const timer = setInterval(() => {
      const seen = Number(localStorage.getItem(KEY) || Date.now());
      if (localStorage.getItem('token') && Date.now() - seen > IDLE_MINUTES * 60000) {
        clearSession();
        navigate('/login', { replace: true });
        message.info(`You were signed out after ${IDLE_MINUTES} minutes without use.`, 0);
      }
    }, 60000);
    return () => {
      clearInterval(timer);
      EVENTS.forEach((e) => window.removeEventListener(e, touch));
    };
  }, [navigate]);
  return null;
}
